/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
@file:Suppress("MatchingDeclarationName")

package studio.oddpods.cauce.feature.onboarding

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.navigation.NavController
import kotlinx.serialization.Serializable
import org.koin.compose.koinInject
import studio.oddpods.cauce.core.data.repository.cauce.ProfileRepository
import studio.oddpods.cauce.core.model.profile.OnboardingStep

@Serializable
data object OnboardingRouterRoute

@Composable
fun OnboardingRouter(
    navController: NavController,
    onCompleted: () -> Unit,
    modifier: Modifier = Modifier,
    profileRepository: ProfileRepository = koinInject(),
) {
    LaunchedEffect(Unit) {
        val profile = profileRepository.getCurrentProfile().getOrNull()
        val step = profile?.onboardingStep ?: OnboardingStep.PAIN_ID
        if (step == OnboardingStep.COMPLETED) {
            onCompleted()
            return@LaunchedEffect
        }
        val target: Any = when (step) {
            OnboardingStep.PAIN_ID -> PainIdRoute
            OnboardingStep.PROFILE -> ProfileSetupRoute
            OnboardingStep.ADD_PATIENT -> AddFirstPatientRoute
            OnboardingStep.LOG_SESSION -> AddFirstPatientRoute
            OnboardingStep.COMPLETED -> return@LaunchedEffect
        }
        navController.navigate(target) {
            popUpTo(OnboardingRouterRoute) { inclusive = true }
        }
    }
    Box(modifier = modifier.fillMaxSize())
}
